'use strict';

var isString = require('lodash/isString');
var isObject = require('lodash/isObject');

/**
 * Verify type of key and return a valid object key used for get treatment for a
 * specific split.
 */
module.exports = function (key) {
  if (isString(key)) {
    return {
      matchingKey: key,
      bucketingKey: key
    };
  }

  if (isObject(key)) {
    if (!key.bucketingKey || !key.matchingKey) {
      throw 'Key object should have properties bucketingKey and matchingKey.';
    }

    return key;
  }

  throw 'Key should be an string or an object with bucketingKey and matchingKey as string properties.';
};


//////////////////
// WEBPACK FOOTER
// ../~/@splitsoftware/splitio/lib/utils/key/parser.js
// module id = 396
// module chunks = 0